import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData from '../gameData';
import HudHelmets from './HudHelmets';

export default class Hud extends Phaser.GameObjects.Container {
  constructor(scene, cointype) {
    super(scene);
    scene.add.existing(this);

    this.scene = scene;

    this.bgStrip = ABCyaPhaser.Graphics.addRect(this.scene.mid.x, 23, 1024, 46, '0x000000', this).setAlpha(.75);

    let sn = '';
    let color;
    let coinspritename = 'coin';
    if (cointype === 'even') {
      sn = 'game.even';
      color = 0xFFFFFF;
      if (gameData.GAME_TYPE === 'jr') {
        sn = 'game.gold';
        color = 0xf4bc44;
      }
    }
    else {
      sn = 'game.odd';
      color = 0xFFFFFF;
      if (gameData.GAME_TYPE === 'jr') {
        coinspritename = 'coin_silver';
        sn = 'game.silver';
        color = 0xcccfd1;
      }
    }

    this.lblType = this.scene.add.bitmapText(0, 0, 'asapBold', ABCyaPhaser.Localization.instance.getLocalizedString(sn), 24).setTintFill(color);
    this.add(this.lblType);
    this.lblType.x = 10;
    this.lblType.y = 22 - this.lblType.height / 2;

    this.coinIcon = ABCyaPhaser.Images.addImage(0, 0, coinspritename, this);
    this.coinIcon.scale = 0.6;
    this.coinIcon.x = this.lblType.x + this.lblType.width + this.coinIcon.getBounds().width / 2 + 10;
    this.coinIcon.y = 23;

    this.xIcon = ABCyaPhaser.Images.addImage(0, 0, 'X', this);
    this.xIcon.x = this.coinIcon.x + (this.coinIcon.getBounds().width * this.coinIcon.scaleX) + 10;
    this.xIcon.y = 23;

    this.lblScore = this.scene.add.bitmapText(0, 0, 'asapReg', '0', 48).setCenterAlign()
      .setTintFill('0xFFFFFF');
    this.lblScore.scale = 0.6;
    this.lblScore.y = 6;
    this.lblScore.x = this.xIcon.x + this.xIcon.getBounds().width + 6;
    this.add(this.lblScore);

    this.helmetContainer = new HudHelmets(this.scene, this);
    this.helmetContainer.x = this.scene.mid.y * 2 - this.helmetContainer.getBounds().width + 150;
    this.helmetContainer.y = 10;
  }

  updateScore(value) {
    this.lblScore.text = value.toString();
  };


  setTimeLeft(value) {
    this.lblTimeLeft.text = `TIME ${value}`;
  };

  helmetCrash(whichOne) {
    if (whichOne < 0) return;
    this.helmetContainer.helmetGone(whichOne);
  };
}